(()=>{
  if(window.wgClosetRevealReady)return;
  window.wgClosetRevealReady=true;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let active=false,overlay=null,restoreOverflow='',prepared=null,preparedUrl='',timer=null,sourceMain=null,sourceInert=false,sourceVisibility='';
  const clean=()=>{
    if(timer!==null)clearTimeout(timer);
    timer=null;
    overlay?.remove();overlay=null;
    if(sourceMain){sourceMain.inert=sourceInert;sourceMain.style.visibility=sourceVisibility}
    sourceMain=null;
    document.documentElement.style.overflow=restoreOverflow;
    active=false;
    document.querySelectorAll('[data-closet-reveal] .wgmm__viewall, [data-closet-reveal] [data-wg-reveal-fast]').forEach(link=>link.removeAttribute('aria-busy'));
    document.querySelectorAll('[data-closet-reveal]').forEach(root=>root.dispatchEvent(new CustomEvent('wg:transition-end')));
  };
  const prepare=url=>{
    if(prepared&&preparedUrl===url)return prepared;
    preparedUrl=url;
    prepared=fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(6000)})
      .then(response=>{if(!response.ok)throw Error('Page unavailable');return response.text()})
      .then(html=>{
        const doc=new DOMParser().parseFromString(html,'text/html');
        const main=doc.getElementById('MainContent');
        if(!main?.querySelector('[data-wg-simple-shop]'))throw Error('Page Two not ready');
        main.querySelectorAll('script').forEach(script=>script.remove());
        const styles=[...new Set([...doc.querySelectorAll('link[rel="stylesheet"][href]')].map(link=>new URL(link.getAttribute('href'),url).href))];
        main.querySelectorAll('link[rel="stylesheet"]').forEach(link=>link.remove());
        return {html:main.innerHTML,styles,title:doc.title};
      }).catch(error=>{prepared=null;throw error});
    return prepared;
  };
  const stylesReady=urls=>Promise.all(urls.map(href=>{
    if([...document.querySelectorAll('link[rel="stylesheet"]')].some(link=>link.href===href))return Promise.resolve();
    return new Promise((resolve,reject)=>{
      const link=document.createElement('link');link.rel='stylesheet';link.href=href;
      link.onload=resolve;link.onerror=reject;document.head.append(link);
      window.setTimeout(reject,5000);
    });
  }));
  const isolateStage=(stage,prefix)=>{
    const ids=new Map();
    stage.querySelectorAll('[id]').forEach(node=>{const old=node.id;const next=prefix+old;ids.set(old,next);node.id=next});
    const references=value=>{for(const [old,next] of [...ids].sort((a,b)=>b[0].length-a[0].length))value=value.replaceAll('#'+old,'#'+next);return value};
    stage.querySelectorAll('*').forEach(node=>{
      for(const attribute of [...node.attributes]){
        if(attribute.name==='id')continue;
        let value=attribute.value;
        if(attribute.name==='for')value=ids.get(value)||value;
        else if(attribute.name==='aria-labelledby'||attribute.name==='aria-describedby')value=value.split(' ').map(id=>ids.get(id)||id).join(' ');
        else value=references(value);
        if(value!==attribute.value)node.setAttribute(attribute.name,value);
      }
      if(node.tagName.toLowerCase()==='style')node.textContent=references(node.textContent);
    });
    stage.querySelectorAll('input[type="radio"]').forEach(input=>input.removeAttribute('name'));
  };
  const makeLeaf=(side,main,rect,width)=>{
    const leaf=document.createElement('div');leaf.className='wg-door-leaf wg-door-leaf--'+side;leaf.style.width=(width/2)+'px';if(side==='right'){leaf.style.left=(width/2)+'px';leaf.style.right='auto'}
    leaf.inert=true;leaf.setAttribute('aria-hidden','true');
    const face=document.createElement('div');face.className='wg-door-face';
    const copy=document.createElement('div');copy.className='wg-door-copy';
    copy.style.width=width+'px';
    if(side==='right')copy.style.left=(-width/2)+'px';
    const clone=main.cloneNode(true);
    clone.querySelectorAll('script,iframe,link[rel="stylesheet"]').forEach(node=>node.remove());
    clone.querySelectorAll('[data-repaired-carousel]').forEach(node=>node.removeAttribute('data-repaired-carousel'));
    clone.removeAttribute('id');
    clone.style.position='absolute';clone.style.width=rect.width+'px';clone.style.left=rect.left+'px';clone.style.top=rect.top+'px';clone.style.margin='0';
    copy.append(clone);face.append(copy);
    const trim=document.createElement('div');trim.className='wg-door-trim';
    const edge=document.createElement('div');edge.className='wg-door-edge';
    const back=document.createElement('div');back.className='wg-door-back';
    leaf.append(back,face,edge);return leaf;
  };
  const destination=link=>new URL(link.href,location.href);
  const eligible=link=>link&&link.closest('[data-closet-reveal]')&&!reduced.matches&&CSS.supports('transform-style','preserve-3d');
  document.addEventListener('pointerover',event=>{
    const link=event.target.closest('.wgmm__viewall, [data-wg-reveal-fast]');
    if(eligible(link))prepare(destination(link).href).catch(()=>{});
  },{passive:true});
  document.addEventListener('focusin',event=>{
    const link=event.target.closest('.wgmm__viewall, [data-wg-reveal-fast]');
    if(eligible(link))prepare(destination(link).href).catch(()=>{});
  });
  document.addEventListener('click',async event=>{
    const link=event.target.closest('.wgmm__viewall, [data-wg-reveal-fast]');
    if(!eligible(link)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(active){event.preventDefault();return}
    const url=destination(link);
    if(url.origin!==location.origin)return;
    event.preventDefault();active=true;link.setAttribute('aria-busy','true');
    restoreOverflow=document.documentElement.style.overflow;
    const root=link.closest('[data-closet-reveal]');
    root.dispatchEvent(new CustomEvent('wg:transition-start'));
    let navigated=false,readyPage=null,fastRequested=false,fastApplied=false,openingStarted=false,releaseOpening=null;
    const finish=()=>{
      if(navigated)return;navigated=true;
      if(readyPage){
        const main=document.getElementById('MainContent');
        if(main){
          main.innerHTML=readyPage.html;
          history.pushState({wgShop:true},'',url.href);
          document.title=readyPage.title;
          clean();window.scrollTo(0,0);
          document.dispatchEvent(new CustomEvent('wg:shop-mounted'));
          const heading=main.querySelector('h1');
          if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true})}
          return;
        }
      }
      location.assign(url.href);
    };
    try{
      const page=await prepare(url.href);
      await stylesReady(page.styles);readyPage=page;
      if(reduced.matches){finish();return}
      const main=document.getElementById('MainContent');
      if(!main)throw Error('Page not ready');
      const rect=main.getBoundingClientRect(),width=document.documentElement.clientWidth;
      overlay=document.createElement('div');overlay.className='wg-door-reveal';
      overlay.setAttribute('role','dialog');overlay.setAttribute('aria-modal','true');overlay.setAttribute('aria-label',root.dataset.revealLabel||'Opening the gallery');
      let duration=Math.min(6000,Math.max(2400,Number(root.dataset.revealDuration)||4800));
      overlay.style.setProperty('--wg-door-duration',duration+'ms');
      const stage=document.createElement('div');stage.className='wg-door-stage';stage.inert=true;stage.setAttribute('aria-hidden','true');stage.innerHTML=page.html;stage.style.width=width+'px';stage.style.right='auto';
      if(matchMedia('(max-width:749px)').matches){
        const rail=stage.querySelector('[data-wg-rail]');
        const first=rail&&[...rail.querySelectorAll('[data-wg-slide]')].find(slide=>[...slide.querySelectorAll('a[href]')].some(link=>(link.getAttribute('href')||'').split(/[?#]/)[0].replace(/\/$/,'').endsWith('/products/short-sleeve-unisex-t-shirt-3')));
        if(first){rail.prepend(first);first.querySelectorAll('img').forEach(image=>image.loading='eager')}
      }


      const softStage=document.createElement('div');softStage.className='wg-door-stage wg-door-stage--soft';
      const haze=document.createElement('div');haze.className='wg-door-haze';haze.setAttribute('aria-hidden','true');
      const left=makeLeaf('left',main,rect,width),right=makeLeaf('right',main,rect,width);
      const skip=document.createElement('button');skip.className='wg-door-skip';skip.type='button';skip.hidden=true;skip.textContent=root.dataset.revealSkip||'Open faster';
      const speedUp=()=>{
        fastRequested=true;releaseOpening?.();
        if(!openingStarted||fastApplied||navigated)return;
        const animations=[left,right,stage,softStage,haze].flatMap(node=>typeof node.getAnimations==='function'?node.getAnimations():[]).filter(animation=>animation.effect&&animation.playState!=='finished');
        if(!animations.length)return;
        let remainingTime=0;
        animations.forEach(animation=>{
          const end=Number(animation.effect.getComputedTiming().endTime),current=Number(animation.currentTime)||0,remaining=Math.max(0,end-current);
          if(!Number.isFinite(end)||remaining===0)return;
          const rate=Math.max(animation.playbackRate||1,remaining/1000);
          animation.updatePlaybackRate(rate);
          remainingTime=Math.max(remainingTime,remaining/rate);
        });
        if(remainingTime===0)return;
        fastApplied=true;skip.setAttribute('aria-disabled','true');
        if(timer!==null)clearTimeout(timer);
        timer=window.setTimeout(finish,remainingTime+1200);
      };
      skip.addEventListener('click',speedUp);
      const sound=document.createElement('div');sound.className='wg-door-sound';const controls=document.querySelector('.wg-soundbar .wg-music-controls');if(controls)sound.append(controls.cloneNode(true));overlay.append(stage,softStage,haze,left,right,skip,sound);document.body.append(overlay);
      sourceMain=main;sourceInert=main.inert;sourceVisibility=main.style.visibility;main.inert=true;main.style.visibility='hidden';
      document.documentElement.style.overflow='hidden';
      sound.querySelector('button')?.focus({preventScroll:true});
      const keyboard=event=>{if(event.key==='Escape'){event.preventDefault();speedUp()}if(event.key==='Tab'){const controls=[...sound.querySelectorAll('button:not(:disabled),input')];if(!controls.length)return;event.preventDefault();const index=controls.indexOf(document.activeElement);controls[(index+(event.shiftKey?-1:1)+controls.length)%controls.length].focus({preventScroll:true})}};
      overlay.addEventListener('keydown',keyboard);
      if(!fastRequested)await Promise.race([Promise.all([...stage.querySelectorAll('img[loading="eager"]')].map(image=>image.decode().catch(()=>{}))),new Promise(resolve=>window.setTimeout(resolve,1200)),new Promise(resolve=>{releaseOpening=resolve})]);
      releaseOpening=null;
      const openingOverlay=overlay;
      left.addEventListener('animationend',event=>{if(event.target===left&&event.animationName==='wg-door-left')finish()},{once:true});
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        if(overlay!==openingOverlay)return;
        if(fastRequested){duration=1000;openingOverlay.style.setProperty('--wg-door-duration','1000ms');fastApplied=true;skip.setAttribute('aria-disabled','true')}
        openingOverlay.classList.add('is-opening');document.dispatchEvent(new CustomEvent('wg:door-opening'));
        timer=window.setTimeout(finish,duration+1200);
        openingStarted=true;
      }));
    }catch{
      clean();finish();
    }
  });
  window.addEventListener('pageshow',event=>{if(event.persisted)clean()});
  window.addEventListener('resize',()=>{if(active&&overlay)location.assign(preparedUrl)});
  reduced.addEventListener('change',()=>{if(active&&preparedUrl)location.assign(preparedUrl)});
})();






